// UbicacionValidator.js (o un archivo similar en tu carpeta de utilidades)
import { FaExclamationTriangle } from "react-icons/fa";

export const validarUbicacion = (ubicacion) => {
    if (!ubicacion || ubicacion.trim() === '') {
    return (
        <span className="text-red-500 text-center font-bold flex items-center">
            <FaExclamationTriangle className="mr-1" /> Completar
        </span>
    );
    }
  
    // Convertir a mayúsculas para hacer la validación insensible a mayúsculas/minúsculas
    const ubicacionUpper = ubicacion.toUpperCase().trim();
  
    // 1. Validar PARED LATERAL (PAR - Sección - Pasillo) Ej: PAR-A-3
    // Ejemplos del documento: PAR-A-3
    const regexParLateral = /^PAR-([A-E])(-\d+)$/;
    if (regexParLateral.test(ubicacionUpper)) {
      // No necesitamos extraer las partes si solo estamos validando el patrón.
      // const [, section, pasillo] = ubicacionUpper.match(regexParLateral);
      // Podrías añadir más validaciones específicas aquí si los números de pasillo tienen un rango.
      return ubicacion;
    }
  
    // 2. Validar PARED FRONTAL (PAR-FRONT - Sección) Ej: PAR-FRONT-A
    // Ejemplos del documento: PAR-FRONT-A, PAR-FRONT-E
    const regexParFrontal = /^PAR-FRONT-([A-E])$/;
    if (regexParFrontal.test(ubicacionUpper)) {
      // const [, section] = ubicacionUpper.match(regexParFrontal);
      return ubicacion;
    }
  
    // 3. Validar ESTANTE (Sección- pasillo - # - Nivel) Ej: B-3-20-N4
    // O (Sección - pasillo - #) Ej: D-1-33
    // Ejemplos del documento: B-3-20-N4
    const regexEstanteConNivel = /^([A-E])(-\d+){2}-N(\d+)$/;
    const regexEstanteSinNivel = /^([A-E])(-\d+){2}$/;
  
    if (regexEstanteConNivel.test(ubicacionUpper)) {
      return ubicacion;
    } else if (regexEstanteSinNivel.test(ubicacionUpper)) {

        return (
            <span className="text-red-500 text-center flex items-center">
                <FaExclamationTriangle className="mr-1" /><span className="text-black-500">{`${ubicacion}`}</span>-N?
            </span>
        );
    }
  
    // 4. Validar GANCHO (GAN- Pasillo - #) Ej: GAN-1-02
    // Ejemplos del documento: GAN-1-02
    const regexGancho = /^GAN(-\d+){2}$/;
    if (regexGancho.test(ubicacionUpper)) {
      return ubicacion;
    }
  
    // 5. Validar MOSTRADOR (M-#) Ej: M-04
    // Ejemplos del documento: M-04
    const regexMostrador = /^M-(\d+)$/;
    if (regexMostrador.test(ubicacionUpper)) {
      return  ubicacion;
    }
  
    // 6. Validar VITRINAS EXTERNAS (EXT-Pasillo-#) Ej: EXT-3-01
    // Ejemplos del documento: EXT-3-01
    const regexVitrinaExterna = /^EXT(-\d+){2}$/;
    if (regexVitrinaExterna.test(ubicacionUpper)) {
      return  ubicacion;
    }
  
    // 7. Validar ESTANTE FRONTAL (FRONT-Sección-pasillo) Ej: FRONT-D-2
    // Ejemplos del documento: FRONT-D-2
    const regexEstanteFrontal = /^FRONT-([A-E])(-\d+)$/;
    if (regexEstanteFrontal.test(ubicacionUpper)) {
      return  ubicacion;
    }
  
    // Si no coincide con ninguna estructura
    return <span className="text-red-500 text-center font-bold flex items-center">
    <FaExclamationTriangle className="mr-1" /> {`U. Inválida: ${ubicacion}`}
</span>

  };